import { MapPin, Phone, Settings, Instagram } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_premium-brew-36/artifacts/glj0sgxs_WhatsApp%20Image%202026-02-18%20at%2018.37.17.jpeg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a2e23] mt-16" data-testid="footer">
      <div className="container-custom pt-32 pb-24 md:pt-40 md:pb-32">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src={LOGO_URL}
                alt="Polje Coffee Co"
                className="w-12 h-12 rounded-full object-cover"
              />
              <span className="font-['Playfair_Display'] text-2xl font-semibold text-[#f5f0e1]">
                Polje Coffee Co
              </span>
            </div>
            <p className="text-[#b8c4b8] leading-relaxed">
              Ankara'nın kalbinde, özenle seçilmiş çekirdekler ve tutkuyla hazırlanan kahveler.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-['Playfair_Display'] text-lg font-semibold text-[#f5f0e1] mb-4">
              Hızlı Bağlantılar
            </h4>
            <ul className="space-y-2">
              {['Ana Sayfa', 'Hakkımızda', 'Menü', 'Yorumlar', 'İletişim'].map((link) => (
                <li key={link}>
                  <a
                    href={link === 'Menü' ? '/menu' : `#${link === 'Ana Sayfa' ? 'hero' : link.toLowerCase().replace('ı', 'i')}`}
                    className="text-[#b8c4b8] hover:text-[#d4a84b] transition-colors"
                    data-testid={`footer-link-${link.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Playfair_Display'] text-lg font-semibold text-[#f5f0e1] mb-4">
              İletişim
            </h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#d4a84b] flex-shrink-0 mt-0.5" />
                <p className="text-[#b8c4b8] text-sm">
                  Ayrancı, Hoşdere Cd. No:116 D:C<br />
                  06540 Çankaya / Ankara
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#d4a84b]" />
                <a href="tel:+905324846373" className="text-[#b8c4b8] hover:text-[#d4a84b] transition-colors text-sm">
                  0532 484 63 73
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Instagram className="w-5 h-5 text-[#d4a84b]" />
                <a href="https://www.instagram.com/poljecoffeeco/" target="_blank" rel="noopener noreferrer" className="text-[#b8c4b8] hover:text-[#d4a84b] transition-colors text-sm">
                  @poljecoffeeco
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-[#3d5a4e] flex flex-col sm:flex-row items-center justify-between gap-4 pb-8">
          <p className="text-[#6b7b6b] text-sm">
            © {currentYear} Polje Coffee Co. Tüm hakları saklıdır.
          </p>
          <a
            href="/admin"
            className="flex items-center gap-2 text-[#6b7b6b] hover:text-[#d4a84b] transition-colors text-sm"
            data-testid="admin-link"
          >
            <Settings className="w-4 h-4" />
            Yönetim Paneli
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
